export default function () {
  const swiper = this;

  const slidesIndexes = [];
  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}



// WEBPACK FOOTER //
// ../src/components/core/manipulation/removeAllSlides.js